import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/life-buoy.vue
var s = {
	name: "DtIconLifeBuoy",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--life-buoy"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Life Buoy",
		viewBox: "0 0 12 12",
		xmlns: "http://www.w3.org/2000/svg"
	}, [i("g", { "clip-path": `url(#${e.uniqueID}a)` }, [...t[0] || (t[0] = [i("path", {
		"fill-rule": "evenodd",
		"clip-rule": "evenodd",
		d: "M6 .5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11Zm0 10a4.48 4.48 0 0 1-2.809-.984l1.43-1.43c.396.262.87.414 1.379.414.51 0 .983-.152 1.379-.414l1.43 1.43A4.48 4.48 0 0 1 6 10.5ZM10.5 6a4.48 4.48 0 0 0-.984-2.809l-1.43 1.43c.262.396.414.87.414 1.379 0 .51-.152.983-.414 1.379l1.43 1.43A4.48 4.48 0 0 0 10.5 6ZM6 3.5c-.51 0-.983.152-1.379.414l-1.43-1.43A4.481 4.481 0 0 1 6 1.5a4.48 4.48 0 0 1 2.809.984l-1.43 1.43A2.488 2.488 0 0 0 6 3.5Zm-3.516-.309A4.481 4.481 0 0 0 1.5 6a4.48 4.48 0 0 0 .984 2.809l1.43-1.43A2.488 2.488 0 0 1 3.5 6c0-.51.152-.983.414-1.379l-1.43-1.43ZM4.5 6a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
		fill: "currentColor"
	}, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=life-buoy.js.map